export const HAKLAI_SAVE_ANALYZE_MESSAGES = Object.freeze({
  genericErrorTitle: "שגיאה",
  dealSaved: "העסקה נשמרה בהצלחה",
  saveFailed: "לא ניתן לשמור את העסקה",
  saveBeforeAnalyzeFailed: "לא ניתן לשמור את העסקה לפני ניתוח",
  analyzeSaved: "העסקה נותחה ונשמרה בהצלחה",
  analyzeFailed: "לא ניתן לנתח את העסקה"
});

export const HAKLAI_PROPERTY_PART_REMOVE_DIALOG = Object.freeze({
  title: "למחוק את רכיב הנכס?",
  expenseDependencies: "ניכויים המשויכים לרכיב",
  depreciationDependencies: "נתוני פחת של הרכיב",
  dependencySeparator: " ו",
  fallbackText: "מחיקה תסיר נתונים המשויכים לרכיב.",
  confirm: "מחק",
  cancel: "ביטול"
});

export const HAKLAI_PRISA_DISABLE_DIALOG = Object.freeze({
  title: "לשנות את הבחירה?",
  text: "שינוי הבחירה ל״לא״ ימחק את הנתונים שהוזנו בסעיף הפריסה. להמשיך?",
  confirm: "כן, שנה",
  cancel: "ביטול"
});

export const getHaklaiPropertyPartRemoveDependentText = (dependentLabels = "") => (
  `מחיקה תסיר גם ${dependentLabels}.`
);

export const joinHaklaiPropertyPartRemoveDependencies = (labels = []) => (
  labels.filter(Boolean).join(HAKLAI_PROPERTY_PART_REMOVE_DIALOG.dependencySeparator)
);
